import type { LineThreadState } from '../thread/lineThreadState'
import type { AttachmentPlanningDigest } from '../attachment/attachmentPlanningIntelligence'

type InterviewQuickControl =
  | { type: 'button'; label: string; value: string }
  | { type: 'radio'; label: string; value: string; group: string }
  | { type: 'checkbox'; label: string; value: string; group: string }

export type LineInterviewQuestionKey =
  | 'outcome'
  | 'dates'
  | 'resources'
  | 'constraints'
  | 'checklists'
  | 'recurrence'
  | 'audience'
  | 'successMetric'

export interface LineInterviewDecision {
  message: string
  quickControls: InterviewQuickControl[]
  askedKeys: LineInterviewQuestionKey[]
  reason: string
}

/**
 * Deterministic interview planner — retired for AI Magic.
 *
 * Line's model prompt now owns the entire interview flow via the
 * CHECKLIST-FIRST STRUCTURAL PHILOSOPHY block plus the
 * PLANNING-MODE INTERVIEW DISCIPLINE block in buildAiMagicChatPrompt.
 * Those two blocks (a) teach Line to detect the DAILY/WEEKLY/INDIVIDUAL
 * checklist archetypes and (b) drive adaptive domain-specific questions,
 * replacing the generic "Any hard constraints, like budget, approvals…"
 * batch this planner used to emit.
 *
 * This function is kept as a stable null shim so aiService.ts's call site
 * (and any future non-AI-Magic caller) doesn't need to change.
 */
export const planLineInterview = (_input: {
  mode: 'generate' | 'edit'
  targetBoard: string
  interviewRequired: boolean
  threadState: LineThreadState
  transcript: string
  attachmentDigest?: AttachmentPlanningDigest | null
  operatingMode?: 'PLANNING' | 'EXECUTION'
}): LineInterviewDecision | null => {
  void _input
  return null
}
